import { render, staticRenderFns } from "./Sixty_percent.vue?vue&type=template&id=15b83206&scoped=true"
import script from "./Sixty_percent.vue?vue&type=script&lang=js"
export * from "./Sixty_percent.vue?vue&type=script&lang=js"
import style0 from "./Sixty_percent.vue?vue&type=style&index=0&id=15b83206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b83206",
  null
  
)

export default component.exports